export interface CongressRegistrationEmailPayload {
  firstName: string;
  lastName: string;
  email: string;
  needsAccommodation: boolean;
  needsTransport: boolean;
  institution: string;
  profession: string;
  licenseType: string;
  licenseNumber: string;
  phone: string;
  paymentType: string;
  sponsorName: string;
  accommodationDates: string[];
  roomType: string;
  roommateName: string;
}

// Backend endpoint for sending confirmation emails.
// You can override with VITE_EMAIL_API_URL if API živi na drugom URL-u.
const EMAIL_API_URL =
  import.meta.env.VITE_EMAIL_API_URL || '/api/send-congress-confirmation';

export async function sendCongressConfirmationEmail(
  payload: CongressRegistrationEmailPayload
) {
  try {
    const response = await fetch(EMAIL_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      console.error('Email API error status:', response.status, text);
    }
  } catch (error) {
    console.error('Neuspješan poziv email API-ja:', error);
  }
}

export interface AbstractCoauthor {
  name: string;
  institution: string;
}

export interface AbstractSubmissionEmailPayload {
  title: string;
  correspondingAuthor: string;
  institution: string;
  email: string;
  phone: string;
  abstractType: string;
  content: string;
  keywords: string;
  coauthors: AbstractCoauthor[];
  documentFileName?: string;
}

const ABSTRACT_EMAIL_API_URL =
  import.meta.env.VITE_ABSTRACT_EMAIL_API_URL || '/api/send-abstract-confirmation';

export async function sendAbstractConfirmationEmail(
  payload: AbstractSubmissionEmailPayload
) {
  try {
    const response = await fetch(ABSTRACT_EMAIL_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      console.error('Email API error status:', response.status, text);
    }
  } catch (error) {
    console.error('Neuspješan poziv email API-ja za sažetak:', error);
  }
}

